export default "__VITE_ASSET__DPZqfMz$__"